import React from 'react'

const LeaderboardError = () => (
    <div className="h-full flex text-white p-4">
      <div className="flex flex-col p-4 bg-transparent rounded-2xl items-center justify-center text-center gap-4">
        {/* <img
          src={emptyPerformanceImg}
          className="w-[105px] h-[105px]"
          alt="empty-performance"
        /> */}
        <div className="flex flex-col gap-1">
          <h3 className="text-black text-base font-medium leading-5">
            Oops! Its not you, its us!
          </h3>
          <p className="text-[#8A919F] text-sm font-normal">
            There is some issue in displaying your leaderboard data currently.
            Please try after sometime.
          </p>
        </div>
      </div>
    </div>
  );
  

export default LeaderboardError;